<template>
  <div class="caret-right" @click="click" :class="{ disabled: disabled }">
    <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="caret-right"
         class="svg-inline--fa fa-caret-right fa-w-7" role="img" xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 224 512">
      <path fill="currentColor"
            d="M0 144.048v223.895c0 42.638 51.731 64.151 81.941 33.941l112-111.943c18.745-18.745 18.746-49.137 0-67.882l-112-111.952C51.792 79.958 0 101.325 0 144.048zM160 256L48 368V144l112 112z"></path>
    </svg>
  </div>
</template>

<script>
export default {
  name: "caret-right",
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    click(e) {
      this.$emit('click', e);
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/svg/caret-right.vue